export const DateFormat = {
  DayMonthNameYear: 'd-MMMM-y',
  MonthDayYear: 'MM/DD/yyyy',
};
